import React from 'react';

function HeadingText({q}) {
    return (
        <div></div>
    );
}

export default HeadingText;